<template>
  <span @keydown.enter.prevent="">
    <v-select
      :value="value"
      :label="label"
      :placeholder="placeholder"
      :multiple="multiple"
      :disabled="disabled"
      :value-comparator="valueComparator"
      :items="items"
      :item-text="itemRender"
      :item-value="itemSelect"
      class="select-field-custom-main-container"
      :menu-props="{ contentClass: 'select-field-custom-content' }"
      box
      :hint="hint"
      :persistent-hint="hint"
      :error-messages="getErrors(validator)"
      @input="$emit('input', $event) && validator && validator.$touch()"
      @blur="validator && validator.$touch()"
      @change="$emit('change', $event)"
    >
      <template v-slot:label="slotProps">
        {{ slotProps.item[itemRender] || slotProps.item }}
      </template>
    </v-select>
  </span>
</template>

<script>
import { defaultMessages, getValidationErrors } from './../../../utils'

export default {
  name: 'select-field',
  props: {
    disabled: Boolean,
    placeholder: {
      type: String,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    chips: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    value: {
      type: [String, Number, Object, Array],
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemRender: {
      type: String,
      default: null,
    },
    itemSelect: {
      type: String,
      default: null,
    },
    validator: {
      type: Object,
      default: null,
    },
    errorMessages: {
      type: Object,
      default: null,
    },
    valueComparator: {
      type: Function,
      default: undefined,
    },
    hint: {
      type: String,
      default: undefined,
    },
  },
  methods: {
    getErrors: function(field) {
      return getValidationErrors({
        ...defaultMessages,
        ...this.errorMessages,
      })(field)
    },
  },
}
</script>
<style>
  .select-field-custom-content .v-select-list {
    width: 50%;
    max-width: 692px;
  }

  .select-field-custom-content .v-list__tile {
    height: auto;
    margin: 10px 0;
    display: flex;
    align-items: center;
  }

  .select-field-custom-content .v-list__tile__content {
    overflow: initial;
    flex: initial;
    height: auto;
    padding: 0;
    margin: 0;
    display: block;
  }

  .select-field-custom-content .v-list__tile__title {
    text-overflow: initial;
    overflow: initial;
    white-space: initial;
    height: auto;
    line-height: initial;
    position: relative;
    overflow-wrap: anywhere;
  }

  .select-field-custom-content .v-select__selections {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: break-spaces;
    overflow-wrap: anywhere !important;
  }

  .select-field-custom-main-container .v-select__selections {
    overflow-wrap: anywhere !important;
  }


  .select-field-custom-content .v-card {
    width: auto;
  }
</style>
